<template>
    <v-dialog v-model="shows" width="320" persistent>
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card light v-bind="{ loading }">
            <v-card-title> {{ title }} <v-spacer /> <v-icon @click="shows = false">mdi-close</v-icon> </v-card-title>
            <v-card-text class="py-0">
                <v-row class="ma-n2">
                    <v-col class="pa-2" cols="12">
                        <v-text-field
                            v-model="form.round"
                            label="청약회차"
                            type="number"
                            placeholder="자동지정"
                            v-bind="{
                                ...attrs_input,
                                disabled: true,
                            }"
                        />
                    </v-col>
                    <v-col class="pa-2" cols="12">
                        <v-datetime-field
                            v-model="form.openAt"
                            label="시작일시"
                            class="pa-0"
                            v-bind="{
                                ...attrs_input,
                                loading,
                            }"
                        />
                    </v-col>
                    <v-col class="pa-2" cols="12">
                        <v-datetime-field
                            v-model="form.deadAt"
                            label="종료일시"
                            class="pa-0"
                            v-bind="{
                                ...attrs_input,
                                loading,
                            }"
                        />
                    </v-col>
                    <v-col class="pa-2" cols="6">
                        <v-switch v-model="form.shows" dense v-bind="attrs_switch">
                            <span slot="label" class="caption white-space-pre-line"> {{ form.shows ? "목록 노출" : "목록 미노출" }} </span>
                        </v-switch>
                    </v-col>
                    <v-col class="pa-2" cols="6">
                        <v-switch v-model="form.stops" dense v-bind="attrs_switch">
                            <span slot="label" class="caption white-space-pre-line"> {{ form.stops ? "청약 금지" : "청약 가능" }} </span>
                        </v-switch>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn text color="primary" @click="save">저장</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import { initApplicationSchedule } from "@/store/schedule";
import { attrs_input, attrs_switch } from "@/assets/variables";

import VDatetimeField from "@/components/plugins/vuetify/v-datetime-field.vue";

export default {
    components: {
        VDatetimeField,
    },
    props: {
        _id: { type: String, default: null },
    },
    data: () => ({
        form: initApplicationSchedule(),

        shows: false,
        loading: false,

        attrs_input,
        attrs_switch,
    }),
    computed: {
        isCreate() {
            return !this._id;
        },
        title() {
            let title = "청약일정";
            title += this.isCreate ? " 생성" : " 수정";
            return title;
        },
    },
    watch: {
        shows() {
            if (this.shows) this.init();
        },
    },
    methods: {
        async init() {
            if (this.loading) return;
            else this.loading = true;
            try {
                if (this.isCreate) {
                    this.form = initApplicationSchedule();
                } else {
                    let { _id } = this;
                    this.form = (await api.console.application.schedules.get({ _id }))?.schedule;
                    this.$emit("input", { ...this.form });
                }
            } finally {
                this.loading = false;
            }
        },
        validates() {
            return true;
        },
        async save() {
            if (!this.validates()) return;

            if (this.loading) return;
            else this.loading = true;

            try {
                let { post, put } = api.console.application.schedules;
                let { ...form } = this.form;
                let schedule = (await (this.isCreate ? post : put)(form))?.schedule;

                alert(this.isCreate ? "생성되었습니다" : "수정되었습니다");
                this.$emit("input", schedule);
                this.shows = false;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .white-space-pre-line {
        white-space: pre-line;
        line-height: 1.3;
    }
}
</style>
